<template>
  <v-dialog v-model="dialogVisible" persistent width="400">
    <v-card>
      <v-card-title class="text-h5 bg-grey-lighten-2">投稿を保存</v-card-title>
      <v-card-text>
        <p>現在の投稿内容を一時保存しますか？</p>
        <p v-if="isInReview" class="mt-2">{{ entryNotices.draftWithdrawsRequest }}</p>
        <p v-if="hasConfirmedContent" class="mt-2">{{ entryNotices.draft }}</p>
      </v-card-text>
      <v-card-actions class="d-flex justify-center">
        <v-btn variant="outlined" class="cancel-button mr-3" @click.stop="dialogVisible = false">
          キャンセル
        </v-btn>
        <v-btn color="primary" variant="flat" class="px-4" @click.prevent="$emit('save-post')">
          保存する
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { entryNotices } from "@/helpers/post-status";

export default defineComponent({
  props: {
    modelValue: { type: Boolean, required: true },
    // TM-9322 U3 BR-U3-3: 確定済みの内容がある投稿か（サーバーが一覧の行に載せた値。既存の投稿を開いているかでは決めない）
    hasConfirmedContent: { type: Boolean, default: false },
    // TM-9322 U3 BR-U3-4: 申請中の投稿か（一時保存すると申請が撤回される）
    isInReview: { type: Boolean, default: false },
  },
  emits: ["update:modelValue", "save-post"],
  data() {
    return { entryNotices };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.modelValue;
      },
      set(value: boolean) {
        this.$emit("update:modelValue", value);
      },
    },
  },
});
</script>

<style lang="scss" scoped>
.cancel-button {
  border-color: #808080 !important;
}
</style>
